export default __webpack_public_path__ + "a1ffa75edb684426b57b7022fdfcccfc.jpeg";